import type { ReactNode } from 'react'
import { isMaskedPostalCode } from 'src/components/checkout/steps/utils'
import { useGlobalContext } from 'src/components/contexts/GlobalContext'
import { dispatchAmplitudeEvent } from 'src/utils/amplitude'
import { getStandardObject } from 'src/utils/amplitude/getStandardObject'

interface PostalCodeTriggerContentProps {
  postalCode?: string
  onOpenModal: () => void
  labelClassName: string
  buttonClassName: string
  buttonSuffix?: ReactNode
}

export function PostalCodeTriggerContent({
  postalCode,
  onOpenModal,
  labelClassName,
  buttonClassName,
  buttonSuffix,
}: PostalCodeTriggerContentProps) {
  const displayPostalCode =
    postalCode && !isMaskedPostalCode(postalCode) ? postalCode : undefined

  const { pageData } = useGlobalContext()

  const handleOpenModal = () => {
    if (!postalCode) {
      dispatchAmplitudeEvent({
        eventName: 'CEP Clicked',
        eventData: {
          ...getStandardObject(pageData),
        },
      })
    }

    onOpenModal()
  }

  return (
    <>
      <span className={labelClassName}>Entrega ou retirada?</span>
      <button
        data-testid="postal-code-button"
        className={buttonClassName}
        onClick={handleOpenModal}
      >
        {!displayPostalCode ? 'Adicione seu CEP' : displayPostalCode}
        {buttonSuffix}
      </button>
    </>
  )
}
